// Multi-pedigree-tabs — feature configuration.
//
// Single master flag for the whole workspace feature. DEFAULT OFF: with this
// false, none of the workspace UI mounts, no new lock behaviour is used, and the
// classic single-pedigree route/flow is exactly as before. Flip to true (or later
// promote to a DB-backed systemFeature) to enable opening several pedigrees at
// once. See claude-MDs/PLAN-multi-pedigree-tabs.md.
export const ENABLE_MULTI_PEDIGREE_TABS = true;

// How many tabs the bottom strip shows before the rest spill into the overflow
// menu / quick switcher. Not a hard limit on how many pedigrees may be open — the
// host bounds how many are actually kept mounted (Phase 4 mount-recent-N).
export const MAX_VISIBLE_TABS = 8;

// A background tab that holds the edit lock releases it automatically once it has
// been saved (no unsaved changes) AND inactive for this long. Keeps "at most one
// edit lock in normal use" true without yanking the lock out from under a user who
// just glanced away mid-edit. (Tim, 2026-07-23.)
export const BACKGROUND_LOCK_IDLE_RELEASE_MS = 120_000;
